// /home/ananun/fluorescence.pro/admin/src/index.js
// index.js

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
ReactDOM.render(<App />, document.getElementById("wrapper"));
